import { parseIsoDate } from "./isoDate";
import { anchorOfStart, formatVolumeDate, isIsoDate, nextDay, } from "./volumeWindow";
export var ANCHOR_VOLUME = "ANCHOR_VOLUME";
export var ATTACH_NEIGHBOUR = "ATTACH_NEIGHBOUR";
export var EMPTY_CHOICES = {};
export var EMPTY_PERIODS = [];
export var outerBoundarySuggestion = function (period) {
    return period.side === "BEFORE"
        ? period.suggestedStartDate
        : period.suggestedEndDate;
};
export var innerBoundary = function (period) {
    return period.side === "BEFORE"
        ? period.suggestedEndDate
        : period.suggestedStartDate;
};
export var resolveChoice = function (period, choice) {
    var _a, _b;
    return ({
        kind: (_a = choice === null || choice === void 0 ? void 0 : choice.kind) !== null && _a !== void 0 ? _a : ANCHOR_VOLUME,
        boundaryDate: (_b = choice === null || choice === void 0 ? void 0 : choice.boundaryDate) !== null && _b !== void 0 ? _b : outerBoundarySuggestion(period),
    });
};
export var isOuterBoundaryValid = function (period, boundaryDate) {
    if (!isIsoDate(boundaryDate))
        return false;
    return period.side === "BEFORE"
        ? boundaryDate <= innerBoundary(period)
        : boundaryDate >= innerBoundary(period);
};
export var areChoicesValid = function (periods, choices) {
    return periods.every(function (period) {
        var resolved = resolveChoice(period, choices[period.side]);
        return (resolved.kind === ATTACH_NEIGHBOUR ||
            isOuterBoundaryValid(period, resolved.boundaryDate));
    });
};
var toResolution = function (resolved) {
    return resolved.kind === ANCHOR_VOLUME
        ? { kind: resolved.kind, boundaryDate: resolved.boundaryDate }
        : { kind: resolved.kind };
};
// only sides the server reported as freed get a resolution, so a stale choice never reaches a side that is not freed
export var buildVolumeWindowRequest = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, periodicalLibraryId = _a.periodicalLibraryId, fillFromSchedule = _a.fillFromSchedule, adoptStartAsAnchor = _a.adoptStartAsAnchor, freedPeriods = _a.freedPeriods, choices = _a.choices;
    var resolutionFor = function (side) {
        var period = freedPeriods.find(function (candidate) { return candidate.side === side; });
        return period ? toResolution(resolveChoice(period, choices[side])) : null;
    };
    return {
        startDate: startDate,
        endDate: endDate,
        before: resolutionFor("BEFORE"),
        after: resolutionFor("AFTER"),
        fillFromSchedule: fillFromSchedule,
        periodicalLibraryId: periodicalLibraryId,
        adoptStartAsAnchor: adoptStartAsAnchor && anchorOfStart(startDate) !== null,
    };
};
// whole calendar months of a window; a partial month rounds to the nearest month
export var monthsBetween = function (startDate, endDate) {
    var start = parseIsoDate(startDate);
    var end = parseIsoDate(nextDay(endDate));
    var months = (end.getFullYear() - start.getFullYear()) * 12 +
        (end.getMonth() - start.getMonth());
    return Math.round(months + (end.getDate() - start.getDate()) / 30);
};
export var formatVolumeRange = function (startDate, endDate) {
    var _a = startDate.split("-").map(Number), startYear = _a[0], startMonth = _a[1], startDay = _a[2];
    var sameYear = startYear === Number(endDate.split("-")[0]);
    var start = sameYear
        ? "".concat(startDay, ". ").concat(startMonth, ".")
        : formatVolumeDate(startDate);
    return "".concat(start, " \u2013 ").concat(formatVolumeDate(endDate));
};
export var findShrunkNeighbour = function (preview, period, created) {
    if (!created || !period.neighbourVolumeId)
        return null;
    var neighbour = preview.neighbours.find(function (candidate) { return candidate.volumeId === period.neighbourVolumeId; });
    return neighbour
        ? {
            labelBefore: neighbour.labelBefore,
            startDate: neighbour.startDate,
            endDate: neighbour.endDate,
            createdLabel: created.label,
        }
        : null;
};
